import React from 'react';
import { X, Minus, Plus, Trash2 } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { useSettings } from '../context/SettingsContext';
import { useNavigate } from 'react-router-dom';
import './CartSidebar.css';

const CartSidebar = () => {
    const { settings } = useSettings();
    const {
        isCartOpen,
        setIsCartOpen,
        cartItems,
        removeFromCart,
        updateQuantity,
        cartTotal
    } = useCart();

    const navigate = useNavigate();

    const handleClose = () => setIsCartOpen(false);

    const handleCheckout = () => {
        handleClose();
        navigate('/checkout');
    };

    return (
        <>
            <div
                className={`cart-sidebar-overlay ${isCartOpen ? 'open' : ''}`}
                onClick={handleClose}
            ></div>
            <div className={`cart-sidebar ${isCartOpen ? 'open' : ''}`}>
                <div className="cart-header">
                    <h2>Votre Panier</h2>
                    <button className="close-cart-btn" onClick={handleClose}>
                        <X size={24} />
                    </button>
                </div>

                <div className="cart-items">
                    {cartItems.length === 0 ? (
                        <div className="empty-cart-message">
                            <p>Votre panier est vide.</p>
                            <button
                                className="btn"
                                style={{ marginTop: '20px', padding: '10px 20px', fontSize: '0.9rem' }}
                                onClick={() => {
                                    handleClose();
                                    navigate('/gateaux');
                                }}
                            >
                                Voir nos gâteaux
                            </button>
                        </div>
                    ) : (
                        cartItems.map((item) => (
                            <div key={item.id} className="cart-item">
                                {item.image ? (
                                    <img src={item.image} alt={item.name} className="cart-item-image" />
                                ) : (
                                    <div className="cart-item-image" style={{ background: '#eee', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        No img
                                    </div>
                                )}
                                <div className="cart-item-details">
                                    <span className="cart-item-title">{item.name}</span>
                                    <span className="cart-item-price">{item.prix} €</span>

                                    <div className="cart-item-controls">
                                        <button
                                            className="qty-btn"
                                            onClick={() => updateQuantity(item.id, item.quantity - 1)}
                                        >
                                            <Minus size={14} />
                                        </button>
                                        <span className="qty-display">{item.quantity}</span>
                                        <button
                                            className="qty-btn"
                                            onClick={() => updateQuantity(item.id, item.quantity + 1)}
                                        >
                                            <Plus size={14} />
                                        </button>

                                        <button
                                            className="remove-btn"
                                            onClick={() => removeFromCart(item.id)}
                                        >
                                            <Trash2 size={16} />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </div>

                {cartItems.length > 0 && (
                    <div className="cart-footer">
                        <div className="cart-total">
                            <span>Total</span>
                            <span>{cartTotal.toFixed(2)} €</span>
                        </div>
                        {settings.isClickCollectDisabled ? (
                            <div style={{ textAlign: 'center', marginTop: '15px', color: '#e74c3c', fontSize: '0.9rem', padding: '10px', background: '#ffebee', borderRadius: '4px' }}>
                                Les commandes en ligne sont temporairement suspendues.
                            </div>
                        ) : (
                            <button className="checkout-btn" onClick={handleCheckout}>
                                Valider la commande
                            </button>
                        )}
                    </div>
                )}
            </div>
        </>
    );
};

export default CartSidebar;
